import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { motion } from 'framer-motion';

const Customers = () => {
  const { t } = useLanguage();

  return (
    <Section id="customers" bg="bg-brand-dark">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <SectionHeading>{t.customers.heading}</SectionHeading>
        <p className="text-xl text-brand-textMuted mt-6">
          {t.customers.subheading}
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {t.customers.items.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group bg-brand-card border border-brand-border rounded-2xl p-8 hover:border-brand-accent/40 transition-all duration-300 flex flex-col items-center text-center"
          >
            {item.logo ? (
              <div className="h-16 mb-6 flex items-center justify-center grayscale group-hover:grayscale-0 transition-all duration-300">
                <img src={item.logo} alt={item.name} className="h-full object-contain" />
              </div>
            ) : (
              <div className="w-16 h-1 bg-brand-accent/30 rounded-full mb-6 group-hover:bg-brand-accent group-hover:w-24 transition-all duration-500"></div>
            )}
            
            <h3 className="text-xl font-bold text-brand-textHeading mb-2">
              {item.name}
            </h3>
            <div className="text-sm font-semibold text-brand-accent uppercase tracking-wider mb-4">
              {item.role}
            </div>
            <p className="text-brand-textMuted text-sm leading-relaxed">
              {item.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default Customers;